import { InternalStepOption } from '@booking-booster-client/models';

export const step2: InternalStepOption = {
  anchorId: 'campaigns',
  stepId: 'campaigns',
  titleTranslationKey: 'ui_tours.statistics_campaigns.step2.title',
  contentTranslationKey: 'ui_tours.statistics_campaigns.step2.content',
  route: '/statistics/campaigns',
};
